import React, { useEffect, useState } from "react";
import styles from "./PrivateProyects.module.scss";
import styled from "styled-components";
import BotoneraModern from "../../components/Botonera/BotoneraModern.tsx";
import { connect } from "react-redux";
import {
  clearProjects,
  closeMainModal,
  resetProjectToEdit,
} from "../../store/actions";
import EmptyState from "../../components/UI/EmptyState/EmptyState";
import useSuscriptionModalTimeout from "../../hooks/useSuscriptionModalTimeout";
import Pagination from "../../hooks/pagination";
import AllProjectsItemEmptyCard from "../../components/Dashboard/AllProjectsItem/AllProjectsItemEmptyCard";
import FilterPrivateProjects from "../../components/Filters/FilterPrivateProjects/FilterPrivateProjects.tsx";
import { ReactComponent as NoResultsIcon } from "../../assets/svg/NoResultsMagnifier.svg";
import { fireAnalytics } from "../../utils/firebase";
import RegisteredUserProfileLoader from "../../components/RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";
import useNavVisibility from "../../hooks/useNavVisibility.ts";
import Breadcrumbs from "../../components/UI/Breadcrumbs/Breadcrumbs.tsx";
import { getSessionId, getDeviceCategory, getPreviousPage, getDashboardSource } from "../../utils/analyticsHelpers.ts";


const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-right: 5%;
  padding-left: 5%;
  max-width: 150rem;
        margin: auto;

  @media (max-width: 1200px) {
    padding-right: 5%;
    padding-left: 5%;
    }

  @media (max-width: 768px) {
    padding-right: 0;
    padding-left: 0;
  }
`;

function PrivateProjects({

  allProjects,
  clearProjects,
  loading,
  userData,
}) {

  const pageNumberLimit = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageLimit, setMaxPageLimit] = useState(5);
  const [minPageLimit, setMinPageLimit] = useState(0);
  const { ocultarEnMobile, mobileStylesFromParent } = useNavVisibility();

  useSuscriptionModalTimeout();

  useEffect(() => {
    clearProjects();
    
    // Nuevo evento estandarizado
    fireAnalytics("page_obras_privadas_view", {
      edify_user_id: userData.id,
      session_id: getSessionId(),
      source: getDashboardSource(),
      previous_page: getPreviousPage(),
      device_category: getDeviceCategory(),
      category: "navigation",
      action: "page_view",
      page_name: "obras_privadas"
    });
  }, []);

  const paginationAttributes = {
    currentPage,
    maxPageLimit,
    minPageLimit,
    response: allProjects,
  };

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const onPrevClick = () => {
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxPageLimit(maxPageLimit - pageNumberLimit);
      setMinPageLimit(minPageLimit - pageNumberLimit);
    }
    setCurrentPage((prev) => prev - 1);
  };

  const onNextClick = () => {
    if (currentPage + 1 > maxPageLimit) {
      setMaxPageLimit(maxPageLimit + pageNumberLimit);
      setMinPageLimit(minPageLimit + pageNumberLimit);
    }
    setCurrentPage((prev) => prev + 1);
  };


  return (
    <Container>
      {ocultarEnMobile && <BotoneraModern mobileStylesFromParent={mobileStylesFromParent} />}
      <div className={styles.componentContainer}>
        <div className={styles.breadcrumbContainer}>
          <Breadcrumbs />
        </div>
        <>
          <FilterPrivateProjects
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            setMaxPageLimit={setMaxPageLimit}
            setMinPageLimit={setMinPageLimit}
            maxPageLimit={maxPageLimit}
            minPageLimit={minPageLimit}
          />
          {Array.isArray(allProjects) && allProjects.length === 0 && !loading ? (
            <div className={styles.emptyState}>
              <EmptyState title="No hay resultados para su búsqueda." icon={<NoResultsIcon width={80} height={80} />} />
            </div>
          ) : loading ? (
            <div className={styles.loaderContainer}>
              <RegisteredUserProfileLoader />
            </div>
          ) : <div className={styles.AllProjects} id="allProjects">
            {allProjects?.itemCount || allProjects?.length > 0 ? (
              <Pagination
                {...paginationAttributes}
                onPrevClick={onPrevClick}
                onNextClick={onNextClick}
                onPageChange={onPageChange}
              />
            ) : (
              <AllProjectsItemEmptyCard />
            )}
          </div>}
        </>
      </div>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.dashboard.loading,
    allProjects: state.dashboard.viewProjects,
    searchParams: state.dashboard.searchParams,
    isFilter: state.dashboard.isFilter,
    page: state.dashboard.page,
    itemCount: state.dashboard.itemCount,
    take: state.dashboard.take,
    proyectos: state.profile.proyectos,
    postulaciones: state.profile.postulations,
    userData: state.general.userData,
    totalPrivateProjects: state.dashboard.totalPrivateProjects,
  };
};

export default connect(mapStateToProps, {
  clearProjects,
  closeMainModal,
  resetProjectToEdit,
})(PrivateProjects);
